export const SUBSCRIPTION_PACKAGES = [
    {
        title: 'Daně a účetnictví',
        key: 'taxes',
        moduleId: 'taxes',
        color: '#F2941A',
        saleBoxBackground: '#FAEFE1',
        redirectLink: 'https://studiow.cz/kurzy?kurz_typ=aktualne&rocni_predplatne=taxes',
        icon: 'D',
        benefits: [
            '80+ webinářů každý rok <br /><a href="https://studiow.cz/kurzy?rocni_predplatne=taxes">Zobrazit nejbližší kurzy</a>',
            'TOP lektoři zodpovídají vaše dotazy',
            'Archiv všech videozáznamů',
            'Školicí materiály ke stažení',
            '1 licence pro 5 osob',
            'Exkluzivní webináře navíc',
        ],
        price: '14 157',
        priceWithoutVat: '11 700',
        eso9: 'CRSWDAU000'
    },
    {
        title: 'Mzdy, pracovní právo a personalistika',
        key: 'wages',
        moduleId: 'wages',
        color: '#F00035',
        saleBoxBackground: '#F7DADA',
        redirectLink: 'https://studiow.cz/kurzy?kurz_typ=aktualne&rocni_predplatne=wages',
        icon: 'M',
        benefits: [
            '80+ webinářů každý rok <br /><a href="https://studiow.cz/kurzy?rocni_predplatne=wages">Zobrazit nejbližší kurzy</a>',
            'TOP lektoři zodpovídají vaše dotazy',
            'Archiv všech videozáznamů',
            'Školicí materiály ke stažení',
            '1 licence pro 5 osob',
            'Exkluzivní webináře navíc',
        ],
        price: '14 157',
        priceWithoutVat: '11 700',
        eso9: 'CRSWMPP000'
    },
    {
        title: 'Veřejná správa',
        key: 'government',
        moduleId: 'government',
        color: '#63BF4D',
        saleBoxBackground: '#E7F5E4',
        redirectLink: 'https://studiow.cz/kurzy?kurz_typ=aktualne&rocni_predplatne=government',
        icon: 'V',
        benefits: [
            '30+ webinářů každý rok <br /><a href="https://studiow.cz/kurzy?rocni_predplatne=government">Zobrazit nejbližší kurzy</a>',
            'TOP lektoři zodpovídají vaše dotazy',
            'Archiv všech videozáznamů',
            'Školicí materiály ke stažení',
            '1 licence pro 5 osob',
            'Exkluzivní webináře navíc',
        ],
        price: '8 349',
        priceWithoutVat: '6 900',
        eso9: 'CRSWVES000'
    },
    {
        title: 'Leadership & Skills for Future',
        key: 'leadershand',
        moduleId: 'leadershand',
        color: '#bc00b0',
        saleBoxBackground: '#E7F5E4',
        redirectLink: 'https://studiow.cz/kurzy?kurz_typ=aktualne&rocni_predplatne=leadershand',
        icon: 'L',
        benefits: [
            '30+ webinářů každý rok <br /><a href="https://studiow.cz/kurzy?rocni_predplatne=leadershand">Zobrazit nejbližší kurzy</a>',
            'TOP lektoři zodpovídají vaše dotazy',
            'Archiv všech videozáznamů',
            'Školicí materiály ke stažení',
            '1 licence pro 5 osob',
            //'Sleva 20 % na kongresy a konference Studia W',
        ],
        price: '13 189',
        priceWithoutVat: '10 900',
        eso9: 'CRSWLEAD000'
    },
];

export const SUBSCRIPTION_PACKAGES_KEYS = [
    'taxes',
    'wages',
    'government',
    'leadershand'
];

export const SUBSCRIPTION_PACKAGES_KEYS_ENUM = {
    TAXES: 'taxes',
    WAGES: 'wages',
    GOVERNMENT: 'government',
    LEADERSHAND: 'leadershand',
};
